export const redirects = [
  // Page redirects
  { from: "/contactus/", to: "/contact-us" },
  { from: "/contactus", to: "/contact-us" },
  { from: "/about/", to: "/about-us" },
  { from: "/about", to: "/about-us" },
  { from: "/arrange-a-viewing/", to: "/viewing-detail" },
  { from: "/arrange-a-viewing", to: "/viewing-detail" },
  { from: "/offers-2/vega/", to: "/offers" },
  { from: "/offers-2/vega", to: "/offers" },
  { from: "/promotional-offers/", to: "/offers" },
  { from: "/promotional-offers", to: "/offers" },
  { from: "/city-village-offers/", to: "/offers" },
  { from: "/city-village-offers", to: "/offers" },
  { from: "/offers-2/pound-field/", to: "/offers" },
  { from: "/offers-2/pound-field", to: "/offers" },
  { from: "/cashback-offers-2025/", to: "/offers" },
  { from: "/cashback-offers-2025", to: "/offers" },

  // City redirects
  { from: "/student-accommodation/coventry/", to: "/coventry" },
  { from: "/student-accommodation/coventry", to: "/coventry" },
  { from: "/student-accommodation/newcastle/", to: "/newcastle" },
  { from: "/student-accommodation/newcastle", to: "/newcastle" },
  { from: "/student-accommodation/glasgow/", to: "/glasgow" },
  { from: "/student-accommodation/glasgow", to: "/glasgow" },
  { from: "/student-accommodation/cambridge/", to: "/cambridge" },
  { from: "/student-accommodation/cambridge", to: "/cambridge" },
  { from: "/student-accommodation/london/", to: "/london" },
  { from: "/student-accommodation/london", to: "/london" },
  { from: "/student-accommodation/exeter/", to: "/exeter" },
  { from: "/student-accommodation/exeter", to: "/exeter" },
  { from: "/student-accommodation/liverpool/", to: "/liverpool" },
  { from: "/student-accommodation/liverpool", to: "/liverpool" },
  { from: "/student-accommodation/leeds/", to: "/leeds" },
  { from: "/student-accommodation/leeds", to: "/leeds" },
  { from: "/student-accommodation/edinburgh/", to: "/edinburgh" },
  { from: "/student-accommodation/edinburgh", to: "/edinburgh" },
  { from: "/student-accommodation/manchester/", to: "/manchester" },
  { from: "/student-accommodation/manchester", to: "/manchester" },

  // Property redirects
  {
    from: "/student-accommodation/coventry/city-village/",
    to: "/coventry/city-village",
  },
  {
    from: "/student-accommodation/coventry/city-village",
    to: "/coventry/city-village",
  },
  { from: "/student-accommodation/newcastle/verde/", to: "/newcastle/verde" },
  { from: "/student-accommodation/newcastle/verde", to: "/newcastle/verde" },
  {
    from: "/student-accommodation/newcastle/the-view/",
    to: "/newcastle/the-view",
  },
  {
    from: "/student-accommodation/newcastle/the-view",
    to: "/newcastle/the-view",
  },
  {
    from: "/student-accommodation/exeter/the-kingfisher/",
    to: "/exeter/the-kingfisher",
  },
  {
    from: "/student-accommodation/exeter/the-kingfisher",
    to: "/exeter/the-kingfisher",
  },
  { from: "/student-accommodation/london/atlas/", to: "/london/atlas" },
  { from: "/student-accommodation/london/atlas", to: "/london/atlas" },
  {
    from: "/student-accommodation/liverpool/the-arch/",
    to: "/liverpool/the-arch",
  },
  {
    from: "/student-accommodation/liverpool/the-arch",
    to: "/liverpool/the-arch",
  },
  {
    from: "/student-accommodation/glasgow/west-village/",
    to: "/glasgow/west-village",
  },
  {
    from: "/student-accommodation/glasgow/west-village",
    to: "/glasgow/west-village",
  },
  { from: "/student-accommodation/leeds/cityside/", to: "/leeds/cityside" },
  { from: "/student-accommodation/leeds/cityside", to: "/leeds/cityside" },
  { from: "/student-accommodation/london/the-lyra/", to: "/london/the-lyra" },
  { from: "/student-accommodation/london/the-lyra", to: "/london/the-lyra" },
  {
    from: "/student-accommodation/manchester/square-gardens/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/",
    to: "/edinburgh/new-park",
  },
  {
    from: "/student-accommodation/edinburgh/new-park",
    to: "/edinburgh/new-park",
  },
  {
    from: "/student-accommodation/glasgow/west-view/",
    to: "/glasgow/west-view",
  },
  {
    from: "/student-accommodation/glasgow/west-view",
    to: "/glasgow/west-view",
  },
  {
    from: "/student-accommodation/liverpool/the-electra/",
    to: "/liverpool/the-electra",
  },
  {
    from: "/student-accommodation/liverpool/the-electra",
    to: "/liverpool/the-electra",
  },
  {
    from: "/student-accommodation/liverpool/myrtle-street/",
    to: "/liverpool/myrtle-street",
  },
  {
    from: "/student-accommodation/liverpool/myrtle-street",
    to: "/liverpool/myrtle-street",
  },

  // Room redirects - Exeter
  {
    from: "/student-accommodation/exeter/the-kingfisher/the-kingfisher-studio-apartments/the-kingfisher-studio-bronze/",
    to: "/exeter/the-kingfisher/studio-bronze",
  },
  {
    from: "/student-accommodation/exeter/the-kingfisher/the-kingfisher-studio-apartments/the-kingfisher-studio-silver/",
    to: "/exeter/the-kingfisher/studio-silver",
  },
  {
    from: "/student-accommodation/exeter/the-kingfisher/the-kingfisher-studio-apartments/the-kingfisher-studio-platinum/",
    to: "/exeter/the-kingfisher/studio-platinum",
  },
  {
    from: "/student-accommodation/exeter/the-kingfisher/the-kingfisher-studio-apartments/the-kingfisher-studio-gold/",
    to: "/exeter/the-kingfisher/studio-gold",
  },
  {
    from: "/student-accommodation/exeter/the-kingfisher/the-kingfisher-studio-apartments/the-kingfisher-studio-classic/",
    to: "/exeter/the-kingfisher",
  },

  // Room redirects - Newcastle Verde
  {
    from: "/student-accommodation/newcastle/verde/verde-studio-apartments/verde-studio-apartment-gold/",
    to: "/newcastle/verde/studio-gold",
  },
  {
    from: "/student-accommodation/newcastle/verde/verde-studio-apartments/verde-studio-apartment-silver/",
    to: "/newcastle/verde/studio-silver",
  },
  {
    from: "/student-accommodation/newcastle/verde/verde-studio-apartments/verde-studio-apartment-platinum/",
    to: "/newcastle/verde/studio-platinum",
  },
  {
    from: "/student-accommodation/newcastle/verde/verde-studio-apartments/verde-studio-silver-plus/",
    to: "/newcastle/verde/studio-silver-plus",
  },
  {
    from: "/student-accommodation/newcastle/verde/verde-studio-apartments/verde-gold-plus/",
    to: "/newcastle/verde/studio-gold-plus",
  },
  {
    from: "/student-accommodation/newcastle/verde/sverde-shared-apartment/verde-premium-en-suite-shared-apartment/",
    to: "/newcastle/the-view",
  },
  {
    from: "/student-accommodation/newcastle/verde/sverde-shared-apartment/verde-classic-ensuite/",
    to: "/newcastle/verde/ensuite-classic",
  },
  {
    from: "/student-accommodation/newcastle/verde/sverde-shared-apartment/verde-deluxe-ensuite/",
    to: "/newcastle/verde/ensuite-deluxe",
  },
  {
    from: "/student-accommodation/newcastle/verde/sverde-shared-apartment/verde-premium-plus-en-suite/",
    to: "/newcastle/verde",
  },
  {
    from: "/student-accommodation/newcastle/verde/sverde-shared-apartment/verde-classic-plus-en-suite/",
    to: "/newcastle/verde",
  },
  {
    from: "/student-accommodation/newcastle/verde/sverde-shared-apartment/verde-classic-ensuite-2/",
    to: "/newcastle/verde/ensuite-classic",
  },

  // Room redirects - Newcastle The View
  {
    from: "/student-accommodation/newcastle/the-view/the-view-shared-apartments/the-view-standard-en-suite/",
    to: "/newcastle/the-view",
  },
  {
    from: "/student-accommodation/newcastle/the-view/the-view-shared-apartments/the-view-deluxe-en-suite/",
    to: "/newcastle/the-view",
  },
  {
    from: "/student-accommodation/newcastle/the-view/the-view-studio-apartments/the-view-studio-apartment-gold/",
    to: "/newcastle/the-view/studio-gold",
  },
  {
    from: "/student-accommodation/newcastle/the-view/the-view-studio-apartments/the-view-studio-apartment-silver/",
    to: "/newcastle/the-view/studio-silver",
  },
  {
    from: "/student-accommodation/newcastle/the-view/the-view-studio-apartments/the-view-studio-apartment-bronze/",
    to: "/newcastle/the-view/studio-bronze",
  },
  {
    from: "/student-accommodation/newcastle/the-view/the-view-studio-apartments/the-view-studio-apartment-platinum/",
    to: "/newcastle/the-view/studio-platinum",
  },

  // Room redirects - Coventry City Village
  {
    from: "/student-accommodation/coventry/city-village/city-village-shared-apartments/city-village-shared-apartment-classic-en-suite-lower-floor/",
    to: "/coventry/city-village/ensuite-classic",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-shared-apartments/city-village-4-bed-apartment/",
    to: "/coventry/city-village",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-shared-apartments/city-village-standard-en-suite-shared-apartment/",
    to: "/coventry/city-village",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-shared-apartments/city-village-premium-en-suite-shared-apartment/",
    to: "/coventry/city-village/ensuite-premium",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-shared-apartments/city-village-deluxe-en-suite-shared-apartment/",
    to: "/coventry/city-village",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-studio-apartments/city-village-studio-apartment-diamond/",
    to: "/coventry/city-village/studio-diamond-1-bed-apartment",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-studio-apartments/city-village-studio-apartment-bronze/",
    to: "/coventry/city-village/studio-bronze",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-studio-apartments/city-village-studio-apartment-platinum/",
    to: "/coventry/city-village/studio-platinum",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-studio-apartments/city-village-studio-apartment-silver/",
    to: "/coventry/city-village/studio-silver",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-studio-apartments/city-village-studio-apartment-gold/",
    to: "/coventry/city-village/studio-gold",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-studio-apartments/city-village-gold-plus-studio/",
    to: "/coventry/city-village/studio-gold",
  },
  {
    from: "/student-accommodation/coventry/city-village/city-village-studio-apartments/dda-gold-city-village/",
    to: "/coventry/city-village/studio-gold",
  },
  {
    from: "/student-accommodation/coventry/city-point/city-point-shared-apartments/3-bed-apartment/",
    to: "/coventry",
  },

  // Room redirects - Manchester Square Gardens
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-apartments/square-gardens-1-bed-apartment/",
    to: "/manchester/square-gardens/apartment-1-bed-apartment%20-floors-2-9-acer-b",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-apartments/square-gardens-1-bed-apartment-17-25/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-apartments/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-shared-apartments/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-shared-apartments/square-gardens-deluxe-ensuite/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-platinum-floors-10-16/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-silver-floors-2-9/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-silver-floors-10-16/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-silver-floors-17-25/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-gold-studio-floors-2-9/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-gold-studio-floors-2-9-2/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-gold-studio-floors-2-9-2-2-2/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-gold-studio-floors-10-16-2/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-gold-studio-floors-17-25/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-platinum-floors-2-9/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-platinum-floors-2-9-2/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-platinum-floors-17-25/",
    to: "/manchester/square-gardens",
  },
  {
    from: "/student-accommodation/manchester/square-gardens/square-gardens-studio-apartments/square-gardens-1-bed-apartment-2/",
    to: "/manchester/square-gardens",
  },

  // Room redirects - Liverpool The Arch
  {
    from: "/student-accommodation/liverpool/the-arch/the-arch-studio-apartments/the-arch-studio-silver/",
    to: "/liverpool/the-arch/studio-silver",
  },
  {
    from: "/student-accommodation/liverpool/the-arch/the-arch-studio-apartments/the-arch-studio-apartments-gold/",
    to: "/liverpool/the-arch/studio-gold",
  },
  {
    from: "/student-accommodation/liverpool/the-arch/the-arch-studio-apartments/the-arch-studio-bronze/",
    to: "/liverpool/the-arch/studio-bronze",
  },
  {
    from: "/student-accommodation/liverpool/the-arch/the-arch-shared-apartments/the-arch-classic-en-suite-shared-apartment/",
    to: "/liverpool/the-arch/ensuite-classic",
  },
  {
    from: "/student-accommodation/liverpool/the-arch/the-arch-shared-apartments/the-arch-deluxe-en-suite/",
    to: "/liverpool/the-arch/ensuite-deluxe",
  },
  {
    from: "/student-accommodation/liverpool/the-arch/the-arch-shared-apartments/the-arch-premium-en-suite-shared-apartment/",
    to: "/liverpool/the-arch/ensuite-premium",
  },

  // Room redirects - Liverpool The Electra
  {
    from: "/student-accommodation/liverpool/the-electra/the-electra-studio-apartments/the-electra-studio-apartment-platinum/",
    to: "/liverpool/the-electra/studio-platinum",
  },
  {
    from: "/student-accommodation/liverpool/the-electra/the-electra-studio-apartments/the-electra-studio-apartment-gold/",
    to: "/liverpool/the-electra/studio-gold",
  },
  {
    from: "/student-accommodation/liverpool/the-electra/the-electra-studio-apartments/the-electra-studio-apartment-silver/",
    to: "/liverpool/the-electra/studio-silver",
  },
  {
    from: "/student-accommodation/liverpool/the-electra/the-electra-studio-apartments/the-electra-studio-apartment-platinum-dda/",
    to: "/liverpool/the-electra/studio-dda-platinum",
  },

  // Room redirects - Glasgow West Village
  {
    from: "/student-accommodation/glasgow/west-village/west-village-studio-apartments/west-village-studio-bronze/",
    to: "/glasgow/west-village/studio-bronze",
  },
  {
    from: "/student-accommodation/glasgow/west-village/west-village-studio-apartments/west-village-studio-gold/",
    to: "/glasgow/west-village/studio-gold",
  },
  {
    from: "/student-accommodation/glasgow/west-village/west-village-studio-apartments/west-village-studio-silver/",
    to: "/glasgow/west-village/studio-silver",
  },
  {
    from: "/student-accommodation/glasgow/west-village/west-village-studio-apartments/west-village-studio-platinum/",
    to: "/glasgow/west-village/studio-platinum",
  },
  {
    from: "/student-accommodation/glasgow/west-village/west-village-studio-apartments/west-village-gold-plus-studio/",
    to: "/glasgow/west-village/studio-gold-plus",
  },
  {
    from: "/student-accommodation/glasgow/west-village/west-village-studio-apartments/west-village-studio-silver-plus/",
    to: "/glasgow/west-village/studio-silver-plus",
  },
  {
    from: "/student-accommodation/glasgow/west-village/west-village-studio-apartments/west-village-studio-gold-plus/",
    to: "/glasgow/west-village/studio-gold-plus",
  },
  {
    from: "/student-accommodation/glasgow/west-village/west-village-shared-apartments/west-village-shared-apartment-premium-dda/",
    to: "/glasgow/west-village/ensuite-dda-premium",
  },
  {
    from: "/student-accommodation/glasgow/west-village/west-village-shared-apartments/west-village-classic-ensuite-upper-floor/",
    to: "/glasgow/west-village/ensuite-classic",
  },

  // Room redirects - Glasgow West View
  {
    from: "/student-accommodation/glasgow/west-view/west-view-studio-apartments/west-view-studio-apartment-silver/",
    to: "/glasgow/west-view/studio-silver",
  },
  {
    from: "/student-accommodation/glasgow/west-view/west-view-studio-apartments/west-view-studio-apartment-gold-dda/",
    to: "/glasgow/west-view/studio-dda-gold",
  },
  {
    from: "/student-accommodation/glasgow/west-view/west-view-studio-apartments/west-view-studio-apartment-platinum/",
    to: "/glasgow/west-view/studio-platinum",
  },
  {
    from: "/student-accommodation/glasgow/west-view/west-view-shared-apartments/west-view-shared-apartment-premium-plus-dda/",
    to: "/glasgow/west-view/ensuite-dda-premium",
  },
  {
    from: "/student-accommodation/glasgow/west-view/west-view-shared-apartments/west-view-shared-apartment-premium-dda/",
    to: "/glasgow/west-view/ensuite-dda-premium",
  },
  {
    from: "/student-accommodation/glasgow/west-view/west-view-shared-apartments/west-view-shared-apartment-classic-plus/",
    to: "/glasgow/west-view/ensuite-classic-plus",
  },
  {
    from: "/student-accommodation/glasgow/west-view/west-view-shared-apartments/west-view-shared-apartment-classic/",
    to: "/glasgow/west-view/ensuite-classic",
  },

  // Room redirects - Leeds Cityside
  {
    from: "/student-accommodation/leeds/cityside/cityside-shared-apartments/cityside-premium-en-suite/",
    to: "/leeds/cityside",
  },
  {
    from: "/student-accommodation/leeds/cityside/cityside-shared-apartments/cityside-deluxe-en-suite/",
    to: "/leeds/cityside/ensuite-deluxe",
  },
  {
    from: "/student-accommodation/leeds/cityside/cityside-studio-apartments/cityside-studio-gold/",
    to: "/leeds/cityside",
  },
  {
    from: "/student-accommodation/leeds/cityside/cityside-studio-apartments/cityside-studio-platinum/",
    to: "/leeds/cityside/studio-platinum",
  },
  {
    from: "/student-accommodation/leeds/cityside/cityside-studio-apartments/cityside-shared-apartment-silver/",
    to: "/leeds/cityside",
  },
  {
    from: "/student-accommodation/leeds/cityside/cityside-studio-apartments/cityside-studio-apartment-silver-dda/",
    to: "/leeds/cityside/studio-dda-silver",
  },
  {
    from: "/student-accommodation/leeds/cityside/cityside-studio-apartments/cityside-studio-apartment-silver-plus/",
    to: "/leeds/cityside/studio-silver-plus",
  },
  {
    from: "/student-accommodation/leeds/cityside/cityside-studio-apartments/bronze-studio/",
    to: "/leeds/cityside/studio-bronze",
  },

  // Room redirects - London The Lyra
  {
    from: "/student-accommodation/london/the-lyra/the-lyra-studio-apartments/the-lyra-studio-bronze/",
    to: "/london/the-lyra/studio-bronze",
  },
  {
    from: "/student-accommodation/london/the-lyra/the-lyra-studio-apartments/the-lyra-gold-studio-dda/",
    to: "/london/the-lyra/studio-dda-gold",
  },
  {
    from: "/student-accommodation/london/the-lyra/the-lyra-studio-apartments/the-lyra-diamond-studio/",
    to: "/london/the-lyra/studio-platinum",
  },
  {
    from: "/student-accommodation/london/the-lyra/the-lyra-studio-apartments/the-lyra-studio-platinum/",
    to: "/london/the-lyra/studio-platinum",
  },
  {
    from: "/student-accommodation/london/the-lyra/the-lyra-studio-apartments/the-lyra-studio-gold/",
    to: "/london/the-lyra/studio-gold",
  },
  {
    from: "/student-accommodation/london/the-lyra/the-lyra-studio-apartments/the-lyra-studio-bronze-plus/",
    to: "/london/the-lyra/studio-bronze-plus",
  },
  {
    from: "/student-accommodation/london/the-lyra/the-lyra-studio-apartments/the-lyra-silver-plus-studio/",
    to: "/london/the-lyra/studio-silver-plus",
  },
  {
    from: "/student-accommodation/london/the-lyra/the-lyra-studio-apartments/the-lyra-studio-silver/",
    to: "/london/the-lyra/studio-silver",
  },

  // Room redirects - Edinburgh New Park
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-shared-apartments/new-park-standard-en-suite/",
    to: "/edinburgh/new-park/ensuite-standard",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-shared-apartments/new-park-premium-en-suite/",
    to: "/edinburgh/new-park/ensuite-premium",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-shared-apartments/new-park-deluxe-en-suite/",
    to: "/edinburgh/new-park/ensuite-deluxe",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-studio-apartments/new-park-studio-apartment-diamond/",
    to: "/edinburgh/new-park/studio-dda-diamond",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-studio-apartments/new-park-studio-apartment-platinum/",
    to: "/edinburgh/new-park/studio-platinum",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-studio-apartments/new-park-studio-gold/",
    to: "/edinburgh/new-park/studio-gold",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-studio-apartments/new-park-studio-bronze/",
    to: "/edinburgh/new-park/studio-bronze",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-studio-apartments/new-park-studio-silver/",
    to: "/edinburgh/new-park/studio-silver",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-studio-apartments/new-park-studio-silver-plus/",
    to: "/edinburgh/new-park/studio-silver-plus",
  },
  {
    from: "/student-accommodation/edinburgh/new-park/new-park-studio-apartments/new-park-studio-gold-plus/",
    to: "/edinburgh/new-park/studio-gold-plus",
  },

  // Cambridge (no room found)
  {
    from: "/student-accommodation/cambridge/the-railyard/the-railyard-shared-apartments/",
    to: "/cambridge",
  },

  // Blog redirects
  {
    from: "/part-time-student-jobs-coventry/",
    to: "/blog/part-time-student-jobs-coventry",
  },
  {
    from: "/everything-you-need-to-know-about-living-with-downing-students/",
    to: "/blog/everything-you-need-to-know-about-living-with-downing-students",
  },
  {
    from: "/a-guide-to-student-travel-discounts-uk/",
    to: "/blog/a-guide-to-student-travel-discounts-uk",
  },
  {
    from: "/book-your-arrival-on-site-facilities/",
    to: "/blog/book-your-arrival-on-site-facilities",
  },
  {
    from: "/easy-ways-to-earn-money-online-as-a-student/",
    to: "/blog/easy-ways-to-earn-money-online-as-a-student",
  },
  { from: "/activities-on-a-budget/", to: "/blog/activities-on-a-budget" },
  {
    from: "/top-tips-for-your-first-uni-grocery-shop/",
    to: "/blog/top-tips-for-your-first-uni-grocery-shop",
  },
  {
    from: "/how-to-celebrate-christmas-in-student-accommodation/",
    to: "/blog/how-to-celebrate-christmas-in-student-accommodation",
  },
  { from: "/student-life/", to: "/blog/student-life" },
  { from: "/red-nose-day/", to: "/blog/red-nose-day" },
  { from: "/vega-open-day/", to: "/blog/vega-open-day" },
  {
    from: "/top-11-holiday-destinations-for-students/",
    to: "/blog/top-11-holiday-destinations-for-students",
  },
  {
    from: "/how-to-make-friends-at-uni-in-student-accommodation/",
    to: "/blog/how-to-make-friends-at-uni-in-student-accommodation",
  },
  { from: "/meet-new-people/", to: "/blog/meet-new-people" },
  { from: "/living-in-leeds/", to: "/blog/living-in-leeds" },
  { from: "/vega-house-party/", to: "/blog/vega-house-party" },
  { from: "/living-in-exeter/", to: "/blog/living-in-exeter" },
  { from: "/jubilee-bake-off/", to: "/blog/jubilee-bake-off" },
  { from: "/get-spring-ready/", to: "/blog/get-spring-ready" },
  { from: "/chinese-new-year/", to: "/blog/chinese-new-year" },
  { from: "/vega-social-event/", to: "/blog/vega-social-event" },
  { from: "/living-in-glasgow/", to: "/blog/living-in-glasgow" },
  {
    from: "/top-10-tips-for-eco-friendly-student-living/",
    to: "/blog/top-10-tips-for-eco-friendly-student-living",
  },
  { from: "/newcastle-open-day/", to: "/blog/newcastle-open-day" },
  { from: "/living-in-coventry/", to: "/blog/living-in-coventry" },
  {
    from: "/10-study-tips-for-keeping-on-top-of-uni/",
    to: "/blog/10-study-tips-for-keeping-on-top-of-uni",
  },
  {
    from: "/moving-out-of-your-student-accommodation/",
    to: "/blog/moving-out-of-your-student-accommodation",
  },
  { from: "/best-parts-of-2021/", to: "/blog/best-parts-of-2021" },
  { from: "/stress-free-student/", to: "/blog/stress-free-student" },
  { from: "/quarantine-for-free/", to: "/blog/quarantine-for-free" },
  {
    from: "/top-tips-for-returning-to-study/",
    to: "/blog/top-tips-for-returning-to-study",
  },
  { from: "/moving-in-checklist/", to: "/blog/moving-in-checklist" },
  { from: "/living-in-newcastle/", to: "/blog/living-in-newcastle" },
  { from: "/living-in-liverpool/", to: "/blog/living-in-liverpool" },
  { from: "/living-in-edinburgh/", to: "/blog/living-in-edinburgh" },
  { from: "/living-in-cambridge/", to: "/blog/living-in-cambridge" },
  { from: "/boost-career-summer/", to: "/blog/boost-career-summer" },
  { from: "/a-level-results-day/", to: "/blog/a-level-results-day" },
  { from: "/a-safe-place-to-live/", to: "/blog/a-safe-place-to-live" },
  {
    from: "/sustainable-student-living-tips/",
    to: "/blog/sustainable-student-living-tips",
  },
  {
    from: "/10-study-tips-for-procrastinators/",
    to: "/blog/10-study-tips-for-procrastinators",
  },
  {
    from: "/energy-saving-tips-for-students/",
    to: "/blog/energy-saving-tips-for-students",
  },
  { from: "/moving-in-checklist-2/", to: "/blog/moving-in-checklist-2" },
  { from: "/living-in-west-london/", to: "/blog/living-in-west-london" },
  { from: "/celebrate-the-jubilee/", to: "/blog/celebrate-the-jubilee" },
  { from: "/take-quiz-type-student/", to: "/blog/take-quiz-type-student" },
  { from: "/living-in-south-london/", to: "/blog/living-in-south-london" },
  {
    from: "/11-tips-surviving-freshers-week/",
    to: "/blog/11-tips-surviving-freshers-week",
  },
  { from: "/five-ideas-fathers-day/", to: "/blog/five-ideas-fathers-day" },
  { from: "/dutch-get-student-life/", to: "/blog/dutch-get-student-life" },
  {
    from: "/top-10-feel-good-christmas-films/",
    to: "/blog/top-10-feel-good-christmas-films",
  },
  { from: "/students-guide-february/", to: "/blog/students-guide-february" },
  { from: "/student-life-in-glasgow/", to: "/blog/student-life-in-glasgow" },
  { from: "/staying-safe-university/", to: "/blog/staying-safe-university" },
  {
    from: "/tips-self-care-university/",
    to: "/blog/tips-self-care-university",
  },
  { from: "/do-i-need-to-quarantine/", to: "/blog/do-i-need-to-quarantine" },
  { from: "/better-manage-time-2016/", to: "/blog/better-manage-time-2016" },
  { from: "/top-graduate-career-tips/", to: "/blog/top-graduate-career-tips" },
  { from: "/eurovision-2023-hotspots/", to: "/blog/eurovision-2023-hotspots" },
  { from: "/become-a-content-creator/", to: "/blog/become-a-content-creator" },
  {
    from: "/top-sustainable-tips-for-recycle-week-2023/",
    to: "/blog/top-sustainable-tips-for-recycle-week-2023",
  },
  { from: "/a-level-results-day-2023/", to: "/blog/a-level-results-day-2023" },
  {
    from: "/student-life-in-edinburgh/",
    to: "/blog/student-life-in-edinburgh",
  },
  {
    from: "/tips-for-travelling-this-christmas-essential-student-checklist/",
    to: "/blog/tips-for-travelling-this-christmas-essential-student-checklist",
  },
  {
    from: "/name-building-competition/",
    to: "/blog/name-building-competition",
  },
  {
    from: "/moving-6-things-need-know/",
    to: "/blog/moving-6-things-need-know",
  },
  {
    from: "/pbsa-hmo-best-student-accommodation/",
    to: "/blog/pbsa-hmo-best-student-accommodation",
  },
  {
    from: "/blog-hobby-ideas-to-start-before-2024-is-over/",
    to: "/blog/blog-hobby-ideas-to-start-before-2024-is-over",
  },
  {
    from: "/write-winning-cover-letter/",
    to: "/blog/write-winning-cover-letter",
  },
  {
    from: "/vega-affordable-3dio-rooms/",
    to: "/blog/vega-affordable-3dio-rooms",
  },
  {
    from: "/top-8-tips-for-celebrating-valentines-day-on-a-budget/",
    to: "/blog/top-8-tips-for-celebrating-valentines-day-on-a-budget",
  },
  {
    from: "/students-preparing-life-uk/",
    to: "/blog/students-preparing-life-uk",
  },
  {
    from: "/student-life-in-manchester/",
    to: "/blog/student-life-in-manchester",
  },
  {
    from: "/top-tips-for-your-first-student-loan/",
    to: "/blog/top-tips-for-your-first-student-loan",
  },
  {
    from: "/best-student-events-spring/",
    to: "/blog/best-student-events-spring",
  },
  {
    from: "/affordable-ways-fun-summer/",
    to: "/blog/affordable-ways-fun-summer",
  },
  {
    from: "/what-to-wear-for-graduation/",
    to: "/blog/what-to-wear-for-graduation",
  },
  {
    from: "/top-tech-help-study-revise/",
    to: "/blog/top-tech-help-study-revise",
  },
  {
    from: "/what-to-bring-to-university/",
    to: "/blog/what-to-bring-to-university",
  },
  {
    from: "/what-to-consider-before-choosing-student-accommodation/",
    to: "/blog/what-to-consider-before-choosing-student-accommodation",
  },
  {
    from: "/10-things-help-feel-home-student-accommodation/",
    to: "/blog/10-things-help-feel-home-student-accommodation",
  },
  {
    from: "/valentines-day-lockdown-fun/",
    to: "/blog/valentines-day-lockdown-fun",
  },
  {
    from: "/blog-why-attending-a-downing-students-event-is-a-good-idea/",
    to: "/blog/blog-why-attending-a-downing-students-event-is-a-good-idea",
  },
  {
    from: "/how-to-study-during-ramadan/",
    to: "/blog/how-to-study-during-ramadan",
  },
  {
    from: "/top-uk-festivals-to-visit-this-summer/",
    to: "/blog/top-uk-festivals-to-visit-this-summer",
  },
  {
    from: "/clearing-2025-are-you-ready/",
    to: "/blog/clearing-2025-are-you-ready",
  },
  {
    from: "/best-firework-displays-2017/",
    to: "/blog/best-firework-displays-2017",
  },
  {
    from: "/why-book-accommodation-early/",
    to: "/blog/why-book-accommodation-early",
  },
  {
    from: "/10-christmas-study-tips-students/",
    to: "/blog/10-christmas-study-tips-students",
  },
  {
    from: "/cheap-easy-meals-make-winter/",
    to: "/blog/cheap-easy-meals-make-winter",
  },
  {
    from: "/8-ways-to-get-a-better-sleep/",
    to: "/blog/8-ways-to-get-a-better-sleep",
  },
  {
    from: "/blog-12-days-of-christmas-giveaway-with-downing-students/",
    to: "/blog/blog-12-days-of-christmas-giveaway-with-downing-students",
  },
  {
    from: "/valentines-date-nights-budget/",
    to: "/blog/valentines-date-nights-budget",
  },
  {
    from: "/5-organisational-tips-students/",
    to: "/blog/5-organisational-tips-students",
  },
  {
    from: "/ucas-discovery-housing-events/",
    to: "/blog/ucas-discovery-housing-events",
  },
  {
    from: "/how-to-beat-the-january-blues/",
    to: "/blog/how-to-beat-the-january-blues",
  },
  {
    from: "/christmas-gift-ideas-students/",
    to: "/blog/christmas-gift-ideas-students",
  },
  {
    from: "/the-uks-best-student-discounts/",
    to: "/blog/the-uks-best-student-discounts",
  },
  { from: "/tips-for-saving-money/", to: "/blog/tips-for-saving-money" },
  {
    from: "/5-top-spring-vegetarian-recipes/",
    to: "/blog/5-top-spring-vegetarian-recipes",
  },
  {
    from: "/make-second-uni-semester-count/",
    to: "/blog/make-second-uni-semester-count",
  },
  {
    from: "/how-to-cope-with-moving-to-uni/",
    to: "/blog/how-to-cope-with-moving-to-uni",
  },
  {
    from: "/helping-students-combat-stress/",
    to: "/blog/helping-students-combat-stress",
  },
  {
    from: "/halloween-snapchat-competition/",
    to: "/blog/halloween-snapchat-competition",
  },
  {
    from: "/best-student-bars-in-newcastle/",
    to: "/blog/best-student-bars-in-newcastle",
  },
  {
    from: "/5-best-summer-events-liverpool/",
    to: "/blog/5-best-summer-events-liverpool",
  },
  { from: "/dissertation-tips/", to: "/blog/dissertation-tips" },
  {
    from: "/ways-to-save-money-as-a-student/",
    to: "/blog/ways-to-save-money-as-a-student",
  },
  {
    from: "/prepare-for-a-level-results-day/",
    to: "/blog/prepare-for-a-level-results-day",
  },
  {
    from: "/6-tips-finding-student-accommodation/",
    to: "/blog/6-tips-finding-student-accommodation",
  },
  {
    from: "/life-after-graduation-the-guide/",
    to: "/blog/life-after-graduation-the-guide",
  },
  { from: "/tips-studying-xmas-break/", to: "/blog/tips-studying-xmas-break" },
  {
    from: "/ucas-clearing-2018-top-tips-for-students/",
    to: "/blog/ucas-clearing-2018-top-tips-for-students",
  },
  {
    from: "/downing-unearths-treasures-arch/",
    to: "/blog/downing-unearths-treasures-arch",
  },
  {
    from: "/diy-mothers-day-gifts-show-care/",
    to: "/blog/diy-mothers-day-gifts-show-care",
  },
  {
    from: "/six-things-consider-choosing-perfect-student-accommodation/",
    to: "/blog/six-things-consider-choosing-perfect-student-accommodation",
  },
  {
    from: "/downing-students-scoop-top-honours-at-annual-student-accommodation-awards/",
    to: "/blog/downing-students-scoop-top-honours-at-annual-student-accommodation-awards",
  },
  {
    from: "/six-top-tips-choosing-perfect-student-accommodation/",
    to: "/blog/six-top-tips-choosing-perfect-student-accommodation",
  },
  {
    from: "/revise-effectively-during-easter/",
    to: "/blog/revise-effectively-during-easter",
  },
  {
    from: "/last-minute-valentines-day-ideas/",
    to: "/blog/last-minute-valentines-day-ideas",
  },
  {
    from: "/guide-best-student-easter-events/",
    to: "/blog/guide-best-student-easter-events",
  },
  {
    from: "/epc-certificates-for-eden-square/",
    to: "/blog/epc-certificates-for-eden-square",
  },
  {
    from: "/23-fun-things-to-do-in-cambridge/",
    to: "/blog/23-fun-things-to-do-in-cambridge",
  },
  {
    from: "/5-questions-away-from-choosing-your-student-accommodation/",
    to: "/blog/5-questions-away-from-choosing-your-student-accommodation",
  },
  {
    from: "/your-guide-to-university-clearing/",
    to: "/blog/your-guide-to-university-clearing",
  },
  { from: "/5-student-wellbeing-tips/", to: "/blog/5-student-wellbeing-tips" },
  {
    from: "/the-ultimate-move-in-out-playlist/",
    to: "/blog/the-ultimate-move-in-out-playlist",
  },
  { from: "/clearing-tips/", to: "/blog/clearing-tips" },
  {
    from: "/students-guide-getting-fit-budget/",
    to: "/blog/students-guide-getting-fit-budget",
  },
  {
    from: "/student-living-expenses-in-the-uk/",
    to: "/blog/student-living-expenses-in-the-uk",
  },
  {
    from: "/8-tips-for-students-surviving-the-dissertation/",
    to: "/blog/8-tips-for-students-surviving-the-dissertation",
  },
  {
    from: "/7-tips-finding-part-time-work-christmas/",
    to: "/blog/7-tips-finding-part-time-work-christmas",
  },
  {
    from: "/how-to-make-friends-at-university/",
    to: "/blog/how-to-make-friends-at-university",
  },
  {
    from: "/celebrating-st-patricks-day-style/",
    to: "/blog/celebrating-st-patricks-day-style",
  },
  {
    from: "/celebrating-chinese-new-year-2024/",
    to: "/blog/celebrating-chinese-new-year-2024",
  },
  {
    from: "/winter-fashion-essentials-students/",
    to: "/blog/winter-fashion-essentials-students",
  },
  {
    from: "/the-dos-and-donts-of-freshers-week/",
    to: "/blog/the-dos-and-donts-of-freshers-week",
  },
  {
    from: "/quick-ways-brush-skills-graduating/",
    to: "/blog/quick-ways-brush-skills-graduating",
  },
  {
    from: "/best-christmas-events-in-your-city/",
    to: "/blog/best-christmas-events-in-your-city",
  },
  {
    from: "/6-part-time-job-ideas-for-students/",
    to: "/blog/6-part-time-job-ideas-for-students",
  },
  {
    from: "/work-for-us-student-ambassador-role/",
    to: "/blog/work-for-us-student-ambassador-role",
  },
  {
    from: "/ultimate-student-guide-to-liverpool/",
    to: "/blog/ultimate-student-guide-to-liverpool",
  },
  {
    from: "/time-management-skills-for-students/",
    to: "/blog/time-management-skills-for-students",
  },
  {
    from: "/ten-cheap-cheerful-ways-fun-january/",
    to: "/blog/ten-cheap-cheerful-ways-fun-january",
  },
  {
    from: "/fathers-day-gift-ideas-for-students/",
    to: "/blog/fathers-day-gift-ideas-for-students",
  },
  {
    from: "/money-saving-tips-students/",
    to: "/blog/money-saving-tips-students",
  },
  {
    from: "/5-reasons-pancake-day-student-dream/",
    to: "/blog/5-reasons-pancake-day-student-dream",
  },
  {
    from: "/ways-to-stay-motivated-at-university/",
    to: "/blog/ways-to-stay-motivated-at-university",
  },
  {
    from: "/reading-week-activities-for-students/",
    to: "/blog/reading-week-activities-for-students",
  },
  {
    from: "/nominate-a-member-of-your-halls-team/",
    to: "/blog/nominate-a-member-of-your-halls-team",
  },
  {
    from: "/top-6-podcasts-for-students-to-listen-to/",
    to: "/blog/top-6-podcasts-for-students-to-listen-to",
  },
  {
    from: "/newcastle-student-union-housing-fair/",
    to: "/blog/newcastle-student-union-housing-fair",
  },
  {
    from: "/inexpensive-gift-ideas-consider-xmas/",
    to: "/blog/inexpensive-gift-ideas-consider-xmas",
  },
  {
    from: "/how-to-decorate-your-university-room/",
    to: "/blog/how-to-decorate-your-university-room",
  },
  {
    from: "/halloween-costumes-for-students-2018/",
    to: "/blog/halloween-costumes-for-students-2018",
  },
  {
    from: "/dealing-with-exam-stress-and-anxiety/",
    to: "/blog/dealing-with-exam-stress-and-anxiety",
  },
  {
    from: "/8-cheap-alternatives-summer-vacation/",
    to: "/blog/8-cheap-alternatives-summer-vacation",
  },
  {
    from: "/nominate-a-downing-students-neighbour/",
    to: "/blog/nominate-a-downing-students-neighbour",
  },
  {
    from: "/how-to-become-an-eco-friendly-student/",
    to: "/blog/how-to-become-an-eco-friendly-student",
  },
  {
    from: "/best-organisational-apps-for-students/",
    to: "/blog/best-organisational-apps-for-students",
  },
  {
    from: "/9-ways-to-enjoy-christmas-on-a-budget/",
    to: "/blog/9-ways-to-enjoy-christmas-on-a-budget",
  },
  {
    from: "/the-lyra-london-1000-silver-500-bronze/",
    to: "/blog/the-lyra-london-1000-silver-500-bronze",
  },
  {
    from: "/places-celebrate-chinese-new-year-2018/",
    to: "/blog/places-celebrate-chinese-new-year-2018",
  },
  {
    from: "/guide-to-living-in-london-as-a-student/",
    to: "/blog/guide-to-living-in-london-as-a-student",
  },
  {
    from: "/best-ways-to-spend-a-mental-health-day/",
    to: "/blog/best-ways-to-spend-a-mental-health-day",
  },
  {
    from: "/ultimate-guide-to-student-life-in-leeds/",
    to: "/blog/ultimate-guide-to-student-life-in-leeds",
  },
  {
    from: "/tiktok-famous-places-in-london-to-visit/",
    to: "/blog/tiktok-famous-places-in-london-to-visit",
  },
  {
    from: "/survival-guide-to-early-morning-classes/",
    to: "/blog/survival-guide-to-early-morning-classes",
  },
  {
    from: "/summer-on-a-budget-when-youre-a-student/",
    to: "/blog/summer-on-a-budget-when-youre-a-student",
  },
  {
    from: "/shared-apartment-vs-studio-best-for-you/",
    to: "/blog/shared-apartment-vs-studio-best-for-you",
  },
  {
    from: "/liverpool-institute-for-performing-arts/",
    to: "/blog/liverpool-institute-for-performing-arts",
  },
  {
    from: "/fun-things-to-do-in-exeter-for-students/",
    to: "/blog/fun-things-to-do-in-exeter-for-students",
  },
  {
    from: "/five-january-fitness-tips-budget/",
    to: "/blog/five-january-fitness-tips-budget",
  },
  {
    from: "/6-ways-to-make-yourself-more-employable/",
    to: "/blog/6-ways-to-make-yourself-more-employable",
  },
  {
    from: "/things-you-need-to-do-before-leaving-uni/",
    to: "/blog/things-you-need-to-do-before-leaving-uni",
  },
  {
    from: "/swap-shops-create-a-sustainable-wardrobe/",
    to: "/blog/swap-shops-create-a-sustainable-wardrobe",
  },
  {
    from: "/newcastle-accommodation-waitlist-2024-25/",
    to: "/blog/newcastle-accommodation-waitlist-2024-25",
  },
  {
    from: "/movies-that-were-filmed-in-your-new-city/",
    to: "/blog/movies-that-were-filmed-in-your-new-city",
  },
  {
    from: "/liverpool-accommodation-waitlist-2023-24/",
    to: "/blog/liverpool-accommodation-waitlist-2023-24",
  },
  {
    from: "/how-to-stay-safe-in-your-university-city/",
    to: "/blog/how-to-stay-safe-in-your-university-city",
  },
  {
    from: "/edinburgh-accommodation-waitlist-2024-25/",
    to: "/blog/edinburgh-accommodation-waitlist-2024-25",
  },
  {
    from: "/edinburgh-accommodation-waitlist-2023-24/",
    to: "/blog/edinburgh-accommodation-waitlist-2023-24",
  },
  {
    from: "/essential-budgeting-tips-for-students/",
    to: "/blog/essential-budgeting-tips-for-students",
  },
  {
    from: "/best-places-to-celebrate-pride-this-year/",
    to: "/blog/best-places-to-celebrate-pride-this-year",
  },
  {
    from: "/a-guide-to-living-in-exeter-as-a-student/",
    to: "/blog/a-guide-to-living-in-exeter-as-a-student",
  },
  {
    from: "/8-summer-jobs-make-summer-more-memorable/",
    to: "/blog/8-summer-jobs-make-summer-more-memorable",
  },
  {
    from: "/7-hotspots-you-have-to-visit-in-coventry/",
    to: "/blog/7-hotspots-you-have-to-visit-in-coventry",
  },
  {
    from: "/12-things-dont-want-to-be-without-at-uni/",
    to: "/blog/12-things-dont-want-to-be-without-at-uni",
  },
  {
    from: "/student-veganuary-being-vegan-on-a-budget/",
    to: "/blog/student-veganuary-being-vegan-on-a-budget",
  },
  {
    from: "/student-essentials-for-a-long-haul-flight/",
    to: "/blog/student-essentials-for-a-long-haul-flight",
  },
  {
    from: "/international-students-studying-in-the-uk/",
    to: "/blog/international-students-studying-in-the-uk",
  },
  {
    from: "/how-to-make-the-most-of-your-summer-break/",
    to: "/blog/how-to-make-the-most-of-your-summer-break",
  },
  {
    from: "/become-a-downing-students-content-creator/",
    to: "/blog/become-a-downing-students-content-creator",
  },
  {
    from: "/9-ways-to-deal-with-being-homesick-at-uni/",
    to: "/blog/9-ways-to-deal-with-being-homesick-at-uni",
  },
  {
    from: "/part-time-jobs-for-students-over-christmas/",
    to: "/blog/part-time-jobs-for-students-over-christmas",
  },
  {
    from: "/its-beginning-to-look-a-lot-like-christmas/",
    to: "/blog/its-beginning-to-look-a-lot-like-christmas",
  },
  {
    from: "/approved-universities-for-affordable-rooms/",
    to: "/blog/approved-universities-for-affordable-rooms",
  },
  {
    from: "/why-university-clearing-can-be-a-good-thing/",
    to: "/blog/why-university-clearing-can-be-a-good-thing",
  },
  {
    from: "/west-village-accommodation-waitlist-2024-25/",
    to: "/blog/west-village-accommodation-waitlist-2024-25",
  },
  {
    from: "/the-benefits-of-sharing-a-flat-in-univeristy/",
    to: "/blog/the-benefits-of-sharing-a-flat-in-univeristy",
  },
  { from: "/study-and-exam-tips/", to: "/blog/study-and-exam-tips" },
  {
    from: "/moving-home-summer-heres-essential-checklist/",
    to: "/blog/moving-home-summer-heres-essential-checklist",
  },
  {
    from: "/clearing-what-to-do-if-you-dont-get-into-uni/",
    to: "/blog/clearing-what-to-do-if-you-dont-get-into-uni",
  },
  {
    from: "/6-things-to-do-in-exeter-during-reading-week/",
    to: "/blog/6-things-to-do-in-exeter-during-reading-week",
  },
  {
    from: "/6-food-drink-spots-london-every-student-know/",
    to: "/blog/6-food-drink-spots-london-every-student-know",
  },
  {
    from: "/student-life-hacks-6-ways-beat-winter-boredom/",
    to: "/blog/student-life-hacks-6-ways-beat-winter-boredom",
  },
  {
    from: "/packing-for-university-the-ultimate-checklist/",
    to: "/blog/packing-for-university-the-ultimate-checklist",
  },
  {
    from: "/10-tips-getting-exam-season/",
    to: "/blog/10-tips-getting-exam-season",
  },
  {
    from: "/how-to-stay-healthy-on-a-budget-at-university/",
    to: "/blog/how-to-stay-healthy-on-a-budget-at-university",
  },
  {
    from: "/accommodation-waitlist-for-2023-24-survey-end/",
    to: "/blog/accommodation-waitlist-for-2023-24-survey-end",
  },
  {
    from: "/a-guide-to-replying-to-your-university-offers/",
    to: "/blog/a-guide-to-replying-to-your-university-offers",
  },
  {
    from: "/5-cheap-eat-places-near-city-village-coventry/",
    to: "/blog/5-cheap-eat-places-near-city-village-coventry",
  },
  {
    from: "/how-to-make-the-most-of-newcastle-student-life/",
    to: "/blog/how-to-make-the-most-of-newcastle-student-life",
  },
  {
    from: "/3-loan-saving-tips-for-students/",
    to: "/blog/3-loan-saving-tips-for-students",
  },
  {
    from: "/6-of-our-favourite-hotspot-areas-in-manchester/",
    to: "/blog/6-of-our-favourite-hotspot-areas-in-manchester",
  },
  {
    from: "/the-kingfisher-250-cashback-or-250-laundry-card/",
    to: "/blog/the-kingfisher-250-cashback-or-250-laundry-card",
  },
  {
    from: "/student-exam-periods-procrastination-eradication/",
    to: "/blog/student-exam-periods-procrastination-eradication",
  },
  {
    from: "/easy-christmas-gift-ideas-cash-strapped-students/",
    to: "/blog/easy-christmas-gift-ideas-cash-strapped-students",
  },
  {
    from: "/mindful-uni-life-taking-care-of-your-mental-health/",
    to: "/blog/mindful-uni-life-taking-care-of-your-mental-health",
  },
  {
    from: "/finding-work-in-the-uk-as-an-international-student/",
    to: "/blog/finding-work-in-the-uk-as-an-international-student",
  },
  {
    from: "/applying-for-clearing-next-steps-towards-university/",
    to: "/blog/applying-for-clearing-next-steps-towards-university",
  },
  {
    from: "/the-18-best-easter-holiday-destinations-for-students/",
    to: "/blog/the-18-best-easter-holiday-destinations-for-students",
  },
  {
    from: "/student-accommodation-energy-performance-certificates/",
    to: "/blog/student-accommodation-energy-performance-certificates",
  },
  {
    from: "/promotional-offers/kingfisher-150-cashback-laundry-card/",
    to: "/blog/promotional-offers",
  },
  {
    from: "/advice-from-a-final-year-student-to-a-first-year-student/",
    to: "/blog/advice-from-a-final-year-student-to-a-first-year-student",
  },
  {
    from: "/how-to-choose-the-right-city-to-make-your-uni-life-thrive/",
    to: "/blog/how-to-choose-the-right-city-to-make-your-uni-life-thrive",
  },
  {
    from: "/my-first-month-at-university-by-cambridge-resident-marilia/",
    to: "/blog/my-first-month-at-university-by-cambridge-resident-marilia",
  },
  {
    from: "/3-wonderful-winter-walks-to-discover-londons-hidden-history/",
    to: "/blog/3-wonderful-winter-walks-to-discover-londons-hidden-history",
  },
  {
    from: "/best-parks-in-your-university-city-for-national-picnic-month/",
    to: "/blog/best-parks-in-your-university-city-for-national-picnic-month",
  },
  {
    from: "/my-international-student-story-by-newcastle-resident-charlotte/",
    to: "/blog/my-international-student-story-by-newcastle-resident-charlotte",
  },
  {
    from: "/downing-students-ultimate-roundup-octobers-best-student-events/",
    to: "/blog/downing-students-ultimate-roundup-octobers-best-student-events",
  },
  {
    from: "/introducing-vega-extraordinary-accomodation-in-the-heart-of-london/",
    to: "/blog/introducing-vega-extraordinary-accomodation-in-the-heart-of-london",
  },
  {
    from: "/reasons-why-downing-students-residents-choose-to-live-with-us-again/",
    to: "/blog/reasons-why-downing-students-residents-choose-to-live-with-us-again",
  },
  {
    from: "/downing-students-gain-british-council-covid-19-safety-accreditation/",
    to: "/blog/downing-students-gain-british-council-covid-19-safety-accreditation",
  },
  {
    from: "/living-in-edinburgh-for-3-years-with-downing-students-annabels-story/",
    to: "/blog/living-in-edinburgh-for-3-years-with-downing-students-annabels-story",
  },
  {
    from: "/how-to-stay-safe-in-your-student-accommodation-by-avoiding-fire-hazards/",
    to: "/blog/how-to-stay-safe-in-your-student-accommodation-by-avoiding-fire-hazards",
  },
  {
    from: "/feeling-overwhelmed-trying-to-find-the-perfect-student-accommodation-were-here-to-help/",
    to: "/blog/feeling-overwhelmed-trying-to-find-the-perfect-student-accommodation-were-here-to-help",
  },
  { from: "/12-reasons-study-exeter/", to: "/blog/12-reasons-study-exeter" },
  {
    from: "/11-things-new-students-will-know-exeter/",
    to: "/blog/11-things-new-students-will-know-exeter",
  },
  {
    from: "/10-things-students-now-want-accommodation/",
    to: "/blog/10-things-students-now-want-accommodation",
  },
  {
    from: "/10-of-the-best-things-to-do-in-south-london/",
    to: "/blog/10-of-the-best-things-to-do-in-south-london",
  },
  {
    from: "/10-of-the-best-cheap-and-cheerful-student-meals/",
    to: "/blog/10-of-the-best-cheap-and-cheerful-student-meals",
  },
  {
    from: "/10-free-things-to-do-in-edinburgh/",
    to: "/blog/10-free-things-to-do-in-edinburgh",
  },
  {
    from: "/10-feel-good-isolation-activities-for-students/",
    to: "/blog/10-feel-good-isolation-activities-for-students",
  },
  {
    from: "/10-apps-a-student-shouldnt-live-without/",
    to: "/blog/10-apps-a-student-shouldnt-live-without",
  },
];

// Create a map for O(1) lookup
export const redirectMap = new Map(redirects.map((r) => [r.from, r.to]));

// Also handle without trailing slash
redirects.forEach((r) => {
  if (r.from.endsWith("/")) {
    redirectMap.set(r.from.slice(0, -1), r.to);
  }
});

// Function to find redirect target
export const findRedirect = (pathname) => {
  // Direct match
  if (redirectMap.has(pathname)) {
    return redirectMap.get(pathname);
  }

  // Try with trailing slash
  if (redirectMap.has(pathname + "/")) {
    return redirectMap.get(pathname + "/");
  }

  // Try without trailing slash
  if (pathname.endsWith("/") && redirectMap.has(pathname.slice(0, -1))) {
    return redirectMap.get(pathname.slice(0, -1));
  }

  return null;
};
